import React from 'react';
import spacing from '../themes/spacing';
import Spinner from '../spinner';
import * as S from './styles';

interface ListProps {
  dataSource: Element[] | JSX.Element[] | React.ReactNode[];
  header?: React.ReactNode;
  footer?: React.ReactNode;
  empty?: number | string | React.ReactNode;
  alignment?: 'horizontal' | 'vertical';
  listSpacing?: keyof typeof spacing;
  listWrapSpacing?: keyof typeof spacing;
  headerSpacing?: keyof typeof spacing;
  footerSpacing?: keyof typeof spacing;
  isLoading?: boolean;
  overflow?: boolean;
  width?: string;
  height?: string;
}

const List = (props: ListProps) => {
  const {
    dataSource = [],
    header = null,
    footer = null,
    empty = null,
    alignment = 'vertical',
    listSpacing = 'xxs',
    listWrapSpacing = 'xxs',
    headerSpacing = 'none',
    footerSpacing = 'none',
    isLoading = false,
    overflow = false,
    width = 'auto',
    height = 'auto',
    ...otherProps
  } = props;

  let listContent;

  if (isLoading) {
    listContent = <Spinner margin={spacing.md} isCenter />;
  } else if (!isLoading && dataSource.length === 0) {
    listContent = <div>{empty}</div>;
  } else {
    listContent = dataSource;
  }

  if (alignment === 'horizontal') {
    return (
      <S.HorizontalList
        listSpacing={spacing[listSpacing]}
        listWrapSpacing={spacing[listWrapSpacing]}
        $overflow={overflow}
        width={width}
        {...otherProps}
      >
        {header && <div key="header">{header}</div>}
        {listContent}
        {footer && <div key="footer">{footer}</div>}
      </S.HorizontalList>
    );
  }

  return (
    <S.ListWrapper width={width}>
      {header}
      <S.VerticalList
        listSpacing={spacing[listSpacing]}
        headerSpacing={spacing[headerSpacing]}
        footerSpacing={spacing[footerSpacing]}
        $overflow={overflow}
        height={height}
        {...otherProps}
      >
        {listContent}
      </S.VerticalList>
      {footer}
    </S.ListWrapper>
  );
};

export default List;
